import { createFileRoute } from '@tanstack/react-router';
import { CampaignsTestsRouteView } from '@/pages/workspaces/automations/[campaignId]/tests/routing';
import { CampaignExperimentsRoute } from './-route-wrappers';

function CampaignTestsRoute() {
  const { campaignId } = Route.useParams();
  return (
    <CampaignsTestsRouteView
      experiments={<CampaignExperimentsRoute campaignId={campaignId} campaignPath="campaigns" />}
    />
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/')({
  component: CampaignTestsRoute,
});
